import { FC } from "react";

export const Skeleton: FC<{ className?: string }> = ({ className }) => {
  return (
    <div
      className={`bg-t_bg_tertiary bg-opacity-15 rounded animate-pulse ${
        className || ""
      }`}
    />
  );
};
